import { render, staticRenderFns } from "./biaozhi.vue?vue&type=template&id=73108bf0&scoped=true"
var script = {}
import style0 from "./biaozhi.vue?vue&type=style&index=0&id=73108bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73108bf0",
  null
  
)

export default component.exports